import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { AssistanceListDTO } from "../models/Assistance/AssistanceListDTO";
import { GetClientAssistanceCreateRequestDTO } from "../models/Assistance/GetClientAssistanceCreateRequestDTO";
import { GetClientAssistanceCreateResponseDTO } from "../models/Assistance/GetClientAssistanceCreateResponseDTO";
import { ClientCreateDTO } from "../models/Client/ClientCreateDTO";
import { ClientDTO } from "../models/Client/ClientDTO";
import { ClientUpdateDTO } from "../models/Client/ClientUpdateDTO";
import { GetAssistancesFromClientDTO } from "../models/Client/GetAssistancesFromClientDTO";
import { GetClientApplicantsResponseDTO } from "../models/Client/GetClientApplicantsResponseDTO";
import { GetEquipmentsFromClientDTO } from "../models/Client/GetEquipmentsFromClientDTO";
import { GetProjectsFromClientDTO } from "../models/Client/GetProjectsFromClientDTO";
import { SearchByClientName } from "../models/Client/SearchByClientName";
import { EquipmentDTO } from "../models/Equipment/EquipmentDTO";
import { GetClientMaintenancePlansRequestDTO } from "../models/MaintenancePlan/GetClientMaintenancePlansRequestDTO";
import { GetClientMaintenancePlansResponseDTO } from "../models/MaintenancePlan/GetClientMaintenancePlansResponseDTO";
import { Parameter } from "../models/Parameter";
import { ClientProfitabilityDTO } from "../models/Profitability/ClientProfitabilityDTO";
import { ClientProfitabilityParametersDTO } from "../models/Profitability/ClientProfitabilityParametersDTO";
import { ProjectDTO } from "../models/Project/ProjectDTO";
import { APIService } from "./APIService";

export class ClientService {
    async GetAllFromErp(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<ClientDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetAllFromErp`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<ClientDTO>(
                false,
                "Erro ao obter a informação dos clientes",
                "",
                [],
                0,
            );
        }
    }



    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<ClientDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<ClientDTO>(
                false,
                "Erro ao obter a informação dos clientes",
                "",
                [],
                0,
            );
        }
    }

    async CreateClient(createClientStatus: ClientCreateDTO): Promise<MessagingHelper<number>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/Client/Create`,
                {
                    ...createClientStatus
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                });
            return response.data;
        } catch (error) {
            return new MessagingHelper<number>(false, "Erro ao ligar ao servidor para criar o cliente", 0);
        };
    }



    async GetByIdErp(idErp: string | undefined): Promise<MessagingHelper<ClientDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Client/${idErp}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação do cliente",
                null
            );
        }
    }



    //pega os detalhes do cliente com o ErpId
    async GetClientById(id: number): Promise<MessagingHelper<ClientDTO | null>> {
        try {
            var response = await APIService.Axios().get(`${APIService.GetURL()}/Client/Details/${id}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + APIService.GetToken(),
                },
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper(
                false,
                "Erro ao ligar ao servidor para ir buscar informação do cliente",
                null,
            );
        }
    }

    async Edit(clientUpdate: ClientUpdateDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/Edit`,
                { ...clientUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para atualizar o cliente",
                null,
            );
        }
    }

    async SearchByName(
        searchParams: SearchByClientName,
    ): Promise<MessagingHelper<ClientDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/SearchByName`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação dos clientes",
                null
            );
        }
    }

    async Delete(id: number): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().delete(
                `${APIService.GetURL()}/Client/Delete/${id}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + APIService.GetToken(),
                },
            },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper(
                false,
                "Erro ao ligar ao servidor para eliminar o cliente",
                null,
            );
        }
    }

    //rentabilidade
    async GetClientProfitability(data: ClientProfitabilityParametersDTO): Promise<MessagingHelper<ClientProfitabilityDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetClientProfitability`,
                {
                    ...data,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<any>(false, "Erro ao obter a rentabilidade do cliente", null);
        }
    }

    async GetPaginatedEquipmentsFromClient(search: GetEquipmentsFromClientDTO): Promise<PaginatedList<EquipmentDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetPaginatedEquipmentsFromClient`,
                {
                    ...search,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<EquipmentDTO>(false, "Ocorreu um erro ao obter os equipamentos do cliente", "", [], 0);
        }
    }

    async GetAssistancesFromClient(search: GetAssistancesFromClientDTO): Promise<PaginatedList<AssistanceListDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetAssistancesFromClient`,
                {
                    ...search,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<AssistanceListDTO>(false, "Ocorreu um erro ao obter as assistências do cliente", "", [], 0);
        }
    }

    async GetProjectsFromClient(search: GetProjectsFromClientDTO): Promise<PaginatedList<ProjectDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetProjectsFromClient`,
                {
                    ...search,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<ProjectDTO>(false, "Ocorreu um erro ao obter as obras do cliente", "", [], 0);
        }
    }

    async GetClientAssistanceCreate(
        searchClient: GetClientAssistanceCreateRequestDTO,
    ): Promise<MessagingHelper<GetClientAssistanceCreateResponseDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetClientAssistanceCreate`,
                {
                    ...searchClient,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter os clientes",
                null
            );
        }
    }

    async GetEquipmentsFromClient(
        searchClient: GetClientAssistanceCreateRequestDTO,
    ): Promise<MessagingHelper<GetClientAssistanceCreateResponseDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetEquipmentsFromClient`,
                {
                    ...searchClient,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter os equipamentos do cliente selecionado",
                null
            );
        }
    }

    async GetMaintenancePlansFromClient(search: GetClientMaintenancePlansRequestDTO): Promise<PaginatedList<GetClientMaintenancePlansResponseDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Client/GetMaintenancePlansFromClient`,
                {
                    ...search,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<GetClientMaintenancePlansResponseDTO>(false, "Ocorreu um erro ao ligar ao servidor para obter os planos de manutenção do cliente", "", [], 0);
        }
    }

    async GetClientApplicants(clientErpId: string): Promise<
        MessagingHelper<GetClientApplicantsResponseDTO[]>
    > {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Client/GetClientApplicants?clientParameter=${clientErpId}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<GetClientApplicantsResponseDTO[]>(
                false,
                "Erro ao ligar ao servidor para obter os requerentes do cliente",
                []
            );
        }
    }
}